import { render, staticRenderFns } from "./LocationIcon.vue?vue&type=template&id=6bd557d6&scoped=true&"
var script = {}
import style0 from "./LocationIcon.vue?vue&type=style&index=0&id=6bd557d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd557d6",
  null
  
)

export default component.exports